import { render, staticRenderFns } from "./invoiceTableTransfer.vue?vue&type=template&id=fbe3a4b4&"
import script from "./invoiceTableTransfer.vue?vue&type=script&lang=js&"
export * from "./invoiceTableTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports